import { APIS } from '../config/apis'
import { ALERT_TYPE, ShowToastMessage } from '@laramie/ui';
import { localService } from './localService'
const ORDEN_IMPRESION_TICKET = 10 //* Valor constante que indica la impresion del ticket en el servicio local
const IMPRESORA = '' // 'EPSON TM-U220 Receipt' //'Microsoft Print to PDF'
const MENSAJE_SIN_IMPRESION = 'En este puesto no hay impresión de tickets configurada'

export const impresionConfigurada = () => Boolean(APIS.URLS.PRINTER)

export const printTicket = (data = []) => {
	if (!impresionConfigurada()) return

    const peticion = {
		Orden: ORDEN_IMPRESION_TICKET,
		Texto: IMPRESORA,
		Id: 0,
		Datos: data,
	}

	localService(
		APIS.URLS.PRINTER,
		'',
		peticion,
		() => {
			ShowToastMessage(ALERT_TYPE.ALERT_INFO, 'Ticket impreso')
		},
		error => {
			ShowToastMessage(ALERT_TYPE.ALERT_ERROR, 'Ocurrió un error al imprimir el ticket')
		}
	)
}

export const printTickets = (tickets = [], { onProgress, onComplete, onError } = {}) => {
	if (!impresionConfigurada()) return
	if (tickets.length === 0) return
	let index = 0
	let printed = 0
	let failed = 0
	const advance = (success) => {
		if (success) printed++
		else failed++
		index++
		setTimeout(printNext, 500)
	}
	const printNext = () => {
		if (index >= tickets.length) {
			onComplete?.({ total: tickets.length, printed, failed })
			if (failed === 0) {
				ShowToastMessage(ALERT_TYPE.ALERT_INFO, `${printed} ${printed === 1 ? 'ticket impreso' : 'tickets impresos'}`)
			} else if (printed === 0) {
				ShowToastMessage(ALERT_TYPE.ALERT_ERROR, `Error al imprimir ${failed} ${failed === 1 ? 'ticket' : 'tickets'}`)
			} else {
				ShowToastMessage(ALERT_TYPE.ALERT_WARNING, `${printed} ${printed === 1 ? 'ticket impreso' : 'tickets impresos'}, ${failed} con error`)
			}
			return
		}
		onProgress?.({ current: index + 1, total: tickets.length })
		const peticion = {
			Orden: ORDEN_IMPRESION_TICKET,
			Texto: IMPRESORA,
			Id: 0,
			Datos: tickets[index],
		}
		let responded = false
		const timeout = setTimeout(() => {
			if (!responded) {
				responded = true
				onError?.({ ticketIndex: index, total: tickets.length })
				advance(false)
			}
		}, 10000)
		localService(
			APIS.URLS.PRINTER,
			'',
			peticion,
			() => {
				if (!responded) {
					responded = true
					clearTimeout(timeout)
					advance(true)
				}
			},
			() => {
				if (!responded) {
					responded = true
					clearTimeout(timeout)
					onError?.({ ticketIndex: index, total: tickets.length })
					advance(false)
				}
			}
		)
	}
	printNext()
}

//* Avisa y devuelve false donde el puesto no imprime: lo usan las impresiones que pide el operador,
//* las automaticas se cortan mudas dentro de printTicket y printTickets.
export const puedeImprimir = () => {
	if (impresionConfigurada()) return true

	ShowToastMessage(ALERT_TYPE.ALERT_INFO, MENSAJE_SIN_IMPRESION)
	return false
}
